import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

import { API_BASE_URL } from '../config/api-config';
import { CurrentFeatureFlagsDto } from '../../shared/models/feature-flag.dto';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${API_BASE_URL}/feature-flags`;

  getCurrentFlags(): Observable<CurrentFeatureFlagsDto> {
    return this.http
      .get<CurrentFeatureFlagsDto>(`${this.baseUrl}/current`)
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }
}
